//musí být jQuery ne $. Jinak to nefunguje :)
var jQuery = require('jquery');

jQuery.migrateMute = true;




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/utils/migratemute.js